/**
 * Renders an ISO timestamp as localized elapsed time ("38 minutes ago", "now"),
 * or "Never" when there is no timestamp.
 */
import React from 'react';
import { useIntl } from 'react-intl';

import { commonMessages } from '../../messages';
import { relativeTimeParts } from './monitoring.util';

interface RelativeTimeProps {
  iso?: string | null;
}

export default function RelativeTime({ iso }: RelativeTimeProps) {
  const { formatMessage, formatRelativeTime } = useIntl();
  const parts = relativeTimeParts(iso);

  if (!parts) {
    return <>{formatMessage(commonMessages.never)}</>;
  }
  return (
    <>{formatRelativeTime(-parts.value, parts.unit, { numeric: 'auto' })}</>
  );
}
